// Libs
import React from "react";
import { Route } from "react-router";
import { BrowserRouter, HashRouter } from "react-router-dom";

// Components
import App from "./components/App";

const routes = (
  <HashRouter>
    <div>
      <Route exact path="/" component={App} />
    </div>
  </HashRouter>
);

export default routes;



// WEBPACK FOOTER //
// ./src/router.js